/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Donatekey_Body1Inputs */

const id_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika Anda memiliki kunci yang ingin Anda sumbangkan ke proyek, silakan isi formulir di bawah ini.`)
};

const ms_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika anda mempunyai kunci yang ingin anda dermakan kepada projek, sila isi borang di bawah.`)
};

const da_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis du har en nøgle du gerne vil donere til projektet, bedes du udfylde formularen nedenfor.`)
};

const de_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Sie einen Schlüssel haben, den Sie an das Projekt spenden möchten, füllen Sie bitte das untenstehende Formular aus.`)
};

const en_us2_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you have a key that you would like to donate to the project, please fill out the form below.`)
};

const es_es2_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tienes una clave que te gustaría donar al proyecto, por favor completa el formulario a continuación.`)
};

const es_mx2_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tienes una llave que te gustaría donar al proyecto, por favor completa el formulario a continuación.`)
};

const fil_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kung mayroon kang key na nais mong i-donate sa proyekto, mangyaring punan ang form sa ibaba.`)
};

const fr_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si vous avez une clé que vous souhaitez donner au projet, veuillez remplir le formulaire ci-dessous.`)
};

const it_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se hai una chiave che desideri donare al progetto, compila il modulo qui sotto.`)
};

const hu_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ha van egy kulcsod, amelyet szeretnél adományozni a projektnek, kérjük, töltsd ki az alábbi űrlapot.`)
};

const nl_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als je een sleutel hebt die je aan het project wilt doneren, vul dan het onderstaande formulier in.`)
};

const no_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis du har en nøkkel du ønsker å donere til prosjektet, vennligst fyll ut skjemaet nedenfor.`)
};

const pl_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeśli masz klucz, który chciałbyś przekazać projektowi, wypełnij poniższy formularz.`)
};

const pt_br2_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se você possui uma chave que gostaria de doar para o projeto, preencha o formulário abaixo.`)
};

const pt_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se tem uma chave que gostaria de doar ao projeto, preencha o formulário abaixo.`)
};

const ro_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dacă ai o cheie pe care dorești să o donezi proiectului, te rugăm să completezi formularul de mai jos.`)
};

const fi_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jos sinulla on avain, jonka haluaisit lahjoittaa projektille, täytä alla oleva lomake.`)
};

const sv_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om du har en nyckel som du vill donera till projektet, fyll i formuläret nedan.`)
};

const vi_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nếu bạn có key muốn quyên góp cho dự án, vui lòng điền vào biểu mẫu bên dưới.`)
};

const tr_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeye bağışlamak istediğiniz bir anahtarınız varsa, lütfen aşağıdaki formu doldurun.`)
};

const cs_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokud máte klíč, který byste chtěli darovat projektu, vyplňte prosím níže uvedený formulář.`)
};

const bg_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ако имате ключ, който бихте искали да дарите на проекта, моля, попълнете формата по-долу.`)
};

const ru_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если у вас есть ключ, который вы хотели бы пожертвовать проекту, пожалуйста, заполните форму ниже.`)
};

const uk_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Якщо у вас є ключ, який ви хотіли б пожертвувати проєкту, будь ласка, заповніть форму нижче.`)
};

const ar_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إذا كان لديك مفتاح ترغب في التبرع به للمشروع، يرجى ملء النموذج أدناه.`)
};

const hi_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यदि आपके पास दान करने के लिए कुंजी है, तो फ़ॉर्म भरें।`)
};

const th_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หากคุณมีคีย์ที่ต้องการบริจาคให้กับโครงการ โปรดกรอกแบบฟอร์มด้านล่าง`)
};

const ja_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトに寄付したいキーをお持ちの場合は、以下のフォームにご記入ください。`)
};

const zh_cn2_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果您有想要捐赠给该项目的Key，请填写下表。`)
};

const zh_hant1_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果您有想要捐贈給該專案的Key，請填寫下表。`)
};

const ko_misc_donatekey_body1 = /** @type {(inputs: Misc_Donatekey_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로젝트에 기부하고 싶은 키가 있다면 아래 양식을 작성해 주세요.`)
};

/**
* | output |
* | --- |
* | "If you have a key that you would like to donate to the project, please fill out the form below." |
*
* @param {Misc_Donatekey_Body1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_donatekey_body1 = /** @type {((inputs?: Misc_Donatekey_Body1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Donatekey_Body1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_donatekey_body1(inputs)
	if (locale === "ms") return ms_misc_donatekey_body1(inputs)
	if (locale === "da") return da_misc_donatekey_body1(inputs)
	if (locale === "de") return de_misc_donatekey_body1(inputs)
	if (locale === "en-US") return en_us2_misc_donatekey_body1(inputs)
	if (locale === "es-ES") return es_es2_misc_donatekey_body1(inputs)
	if (locale === "es-MX") return es_mx2_misc_donatekey_body1(inputs)
	if (locale === "fil") return fil_misc_donatekey_body1(inputs)
	if (locale === "fr") return fr_misc_donatekey_body1(inputs)
	if (locale === "it") return it_misc_donatekey_body1(inputs)
	if (locale === "hu") return hu_misc_donatekey_body1(inputs)
	if (locale === "nl") return nl_misc_donatekey_body1(inputs)
	if (locale === "no") return no_misc_donatekey_body1(inputs)
	if (locale === "pl") return pl_misc_donatekey_body1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_donatekey_body1(inputs)
	if (locale === "pt") return pt_misc_donatekey_body1(inputs)
	if (locale === "ro") return ro_misc_donatekey_body1(inputs)
	if (locale === "fi") return fi_misc_donatekey_body1(inputs)
	if (locale === "sv") return sv_misc_donatekey_body1(inputs)
	if (locale === "vi") return vi_misc_donatekey_body1(inputs)
	if (locale === "tr") return tr_misc_donatekey_body1(inputs)
	if (locale === "cs") return cs_misc_donatekey_body1(inputs)
	if (locale === "bg") return bg_misc_donatekey_body1(inputs)
	if (locale === "ru") return ru_misc_donatekey_body1(inputs)
	if (locale === "uk") return uk_misc_donatekey_body1(inputs)
	if (locale === "ar") return ar_misc_donatekey_body1(inputs)
	if (locale === "hi") return hi_misc_donatekey_body1(inputs)
	if (locale === "th") return th_misc_donatekey_body1(inputs)
	if (locale === "ja") return ja_misc_donatekey_body1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_donatekey_body1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_donatekey_body1(inputs)
	return ko_misc_donatekey_body1(inputs)
});
export { misc_donatekey_body1 as "misc.donateKey.body" }